import { Typography, styled } from '@mui/material'

export const StyledArticleBody = styled(Typography)`
  font-size: 18px;
  line-height: 32px;
`

export const StyledArticleBox = styled('div')`
  font-size: 18px;
  line-height: 32px;
`
